module.exports = __webpack_public_path__ + "img/window_cleaning.90b74dce.jpg";